/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from 'react';
import { CrestPlaceholder, Text, Icon } from '@veo/web-design-system';
import { ITeam } from 'src/common/model/interfaces/ITeam';
import styles from './item.module.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  team?: ITeam;
  open?: boolean;
};

export const TeamSelectorItem = forwardRef(({
  team,
  open = false,
  ...buttonProps
}: Props, ref: React.ForwardedRef<HTMLButtonElement>) => {
  if (!team) {
    return null;
  }

  const crest = team.crest ? (
    <img
      src={team.crest}
      className={styles['team-selector-item__crest']}
      alt={`${team.name} crest`}
    />
  ) : (
    <CrestPlaceholder size="xs" />
  );

  return (
    <li>
      <button
        type="button"
        ref={ref}
        {...buttonProps}
        className={styles['team-selector-item__button']}
        role="menuitem"
      >
        {crest}
        <Text type="div" weight="bold" className={styles['team-selector-item__name']}>
          {team.name}
        </Text>
        <Icon name={open ? 'chevron-up' : 'chevron-down'} size="xs" />
      </button>
    </li>
  );
});
